import React from 'react';
import '../Section10/component.css';

const Section14 = () => {
  return (
    <div className="svc-intro">
      <div className="svc-intro-inner">
        <span className="svc-label">Development</span>
        <h2 className="svc-intro-title">Your Expert Partner in App Development: Android & iOS</h2>
        <p className="svc-intro-body">
          At Hypertonic IT Solutions, we specialize in crafting high-quality, innovative, and user-friendly mobile applications for both Android and iOS platforms. With our team of experienced developers and designers, we are dedicated to bringing your app ideas to life and delivering exceptional results that meet your business objectives.
        </p>
      </div>
    </div>
  );
};

export default Section14;
